import {
    getDataWithParams,
    destroyData,
    uploadData,
    getAllData,
    postData,
    downloadFile
} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    detail_id: null,
    topic: null,
    description: null,
    proposal: null,
    student_role: null,
    proposalFileName: null,
    proposalFilePath: null,
    rejectionNote: null,
    mentor_id: null,
    mentor_name: null,
    dosen_id: null,
    dosen_name: null,
    dosen_username: null
}

const anggotaInit = {
    id: null,
    studentType: null,
    student_role: null,
    entrepreneurship_id: null,
    nik: null,
    institution: null,
    name: null
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "DESC",
    search: null,
    filter: null
}
const initialState = () => ({
    data: {},
    dataKewir: {},
    msg: "Jaringan Bermasalah",
    status: 0,
    request: {...requestInit},
    item: {...itemInit},
    itemAnggota: {...anggotaInit},
    kewirStatus: [
        {
            class: "y-alert-warning",
            value: "Menunggu verifikasi prodi",
            status: 0
        },
        {
            class: "y-alert-primary2",
            value: "Menunggu verifikasi dospemb",
            status: 1
        },
        {
            class: "y-alert-primary",
            value: "Pendaftaran Selesai",
            status: 2
        },
        {
            class: "y-alert-warning2",
            value: "Pelaksanaan & Penilaian Ujian",
            status: 3
        },
        {
            class: "y-alert-success",
            value: "Sudah Ujian",
            status: 4
        },
        {
            class: "y-alert-error",
            value: "Pendaftaran ditolak prodi",
            status: 91
        },
        {
            class: "y-alert-error",
            value: "Ditolak oleh dospem",
            status: 92
        },
        {
            class: "y-alert-error",
            value: "Ditolak oleh TU",
            status: 93
        },
    ],
    newKewirStatus: [
        {
            class: "warning",
            value: "Menunggu verifikasi prodi",
            status: 0
        },
        {
            class: "primary2",
            value: "Menunggu verifikasi dospemb",
            status: 1
        },
        {
            class: "primary",
            value: "Pendaftaran Selesai",
            status: 2
        },
        {
            class: "warning2",
            value: "Pelaksanaan & Penilaian Ujian",
            status: 3
        },
        {
            class: "success",
            value: "Sudah Ujian",
            status: 4
        },
        {
            class: "error",
            value: "Pendaftaran ditolak prodi",
            status: 91
        },
        {
            class: "error",
            value: "Ditolak oleh dospem",
            status: 92
        },
        {
            class: "error",
            value: "Ditolak oleh TU",
            status: 93
        },
    ],
    advisorStatus: [
        {
            class: "y-alert-warning",
            value: "Menunggu verifikasi dospem",
            status: 0
        },
        {
            class: "y-alert-primary2",
            value: "Bersedia",
            status: 1
        },
        {
            class: "y-alert-error",
            value: "Tidak Bersedia",
            status: 91
        }
    ],
    listAnggota: [],
    blobData: null,
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getDataKewir: state => state.dataKewir,
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getItemAnggota: state => state.itemAnggota,
    getAllStatus: state => state.kewirStatus,
    getKewirStatus: state => (status) => state.kewirStatus.find(x => x.status == status),
    getNewKewirStatus: state => (status) => state.newKewirStatus.find(x => x.status == status),
    getAdvisorStatus: state => (advisorStatus) => state.advisorStatus.find(x => x.status == advisorStatus),
    getListAnggota: state => state.listAnggota || [],
    getBlobData: state => state.blobData
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.msg
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_DATA_KEWIR(state, value) {
        state.dataKewir = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    SET_ITEM_ANGGOTA(state, value) {
        state.itemAnggota = value
    },
    SET_ANGGOTA(state, value) {
        state.listAnggota = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',value)
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    setItemAnggota({commit}, value){
        commit('SET_ITEM_ANGGOTA',value)
    },
    resetItemAnggota({commit}){
        commit('SET_ITEM_ANGGOTA', {...anggotaInit})
    },
    setAnggota({commit}, value){
        commit('SET_ANGGOTA',value)
    },
    async getStudentVerify({commit, state}) {
        try {
            const response = await getDataWithParams('/entrepreneurship', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getEntrepreneurshipStudent({commit, state}) {
        try {
            const response = await getDataWithParams('/entrepreneurship-student', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async store({commit }, data) {
        try {
            const response = await uploadData('/entrepreneurship-student', data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async update({commit }, {data, id}) {
        try {
            const url = `/entrepreneurship-student/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async destroy({commit }, id) {
        try {
            const url = `/entrepreneurship-student/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAnggota({commit }, id) {
        try {
            const url = `/entrepreneurship-anggota/${id}`
            const response = await getAllData(url)
            commit('SET_RESPONSE', response.data)
            commit('SET_ANGGOTA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async storeAnggota({commit }, {data, id}) {
        try {
            const url = `/entrepreneurship-anggota/${id}`
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async updateAnggota({commit }, data) {
        try {
            const url = `/entrepreneurship-anggota/update/${data.id}`
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async destroyAnggota({commit }, id) {
        try {
            const url = `/entrepreneurship-anggota/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async getDataKewirById({commit }, id) {
        try {
            const url = `/entrepreneurship/${id}`
            const response = await getAllData(url)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA_KEWIR', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async verify({commit }, {type, data}) {
        try {
            const url = `/entrepreneurship-verify/${type}`
            var response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async downloadFile({commit }, {item, type}) 
    {
        try {
            const url = `/entrepreneurship/proposal/${item.id}`
            const payload = {
                ...item
            }
            delete payload.id
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}